<div class="row mb-3">
    <div class="col-md-8">
        <h3>{{pageTitle}}</h3>
    </div>
    <div class="col-md-4">
        <span class="float-right ml-auto">
            <button class="btn btn-default" type="button" *ngIf="isPermissionExists" (click)="goToAddBanner();">
                Add Banner
            </button>
        </span>
    </div>
</div>

<mat-tab-group (selectedTabChange)="onTabChanged($event)">
    <mat-tab label="Published">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-12 mt-2">
                    <div class="row" *ngFor="let alert of alerts" class="padding-b-15">
                        <div class="alert alert-dismissible" [ngClass]="{'alert-danger': alert.type === 'error','alert-success': alert.type === 'success'}">
                            <button type="button" class="close" data-dismiss="alert" (click)="closeAlerts()">×</button>
                            {{ alert.msg }}
                        </div>
                    </div>
                    <div class="row" *ngIf="success.length > 0" class="padding-b-15">
                        <div class="alert alert-success">
                            <button type="button" class="close" data-dismiss="alert" (click)="closeSuccess()">×</button>
                            <span>{{ success[0].msg }}</span>
                            <ul>
                                <li *ngFor="let obj of success">{{obj.banner}}</li>
                            </ul>
                        </div>
                    </div>
                    <div class="row" *ngIf="failure.length > 0" class="padding-b-15">
                        <div class="alert alert-danger">
                            <button type="button" class="close" data-dismiss="alert" (click)="closeFailure()">×</button>
                            <span>{{failure[0].msg}}</span>
                            <ul>
                                <li *ngFor="let obj of failure">{{obj.banner}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Material Table -->
            <div *ngIf="bannerStatus === 'Publish' && bannerDataSource && bannerDataSource.data.length === 0">
                {{ "Label.published_banner_not_available" | translate}}</div>
            <div *ngIf="bannerStatus === 'Draft' && bannerDataSource && bannerDataSource.data.length === 0">
                {{ "Label.banner_not_available" | translate}}</div>

            <div class="col-md-12 p-0" *ngIf="bannerDataSource && bannerDataSource.data.length >0">
                <mat-form-field class="float-right">
                    <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                </mat-form-field>
                <table aria-describedby="banner-list" aria-labelledby="banner-list" mat-table [dataSource]="bannerDataSource" matSort class="col-md-12 banner-table mat-elevation-z8">
                    <ng-container matColumnDef="select">
                        <th id="banner-select" class="resource-header-card" mat-header-cell *matHeaderCellDef>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <mat-checkbox class="pl-checkbox" (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(element) : null"
                                [checked]="selection.isSelected(element)">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="title">
                        <th id="banner-name" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Banner Title </th>
                        <td mat-cell *matCellDef="let element"> {{element.title}} </td>
                    </ng-container>

                    <ng-container matColumnDef="contentType">
                        <th id="banner-type" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Content Type </th>
                        <td mat-cell *matCellDef="let element"> {{element.contentType}} </td>
                    </ng-container>

                    <ng-container matColumnDef="category">
                        <th id="banner-type" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header>Category</th>
                        <td mat-cell *matCellDef="let element"> {{element.category}} </td>
                    </ng-container>

                    <ng-container matColumnDef="createdBy">
                        <th id="banner-modified-by" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Created By </th>
                        <td mat-cell *matCellDef="let element"> {{element.createdBy}} </td>
                    </ng-container>

                    <ng-container matColumnDef="createdAt">
                        <th id="banner-modified-date" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> {{ "Label.createdDate" | translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.createdAt | date:'short'}} </td>
                    </ng-container>

                    <ng-container matColumnDef="updatedBy">
                        <th id="banner-modified-by" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Published By </th>
                        <td mat-cell *matCellDef="let element"> {{element.updatedBy}} </td>
                    </ng-container>

                    <ng-container matColumnDef="updatedAt">
                        <th id="banner-date" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> {{ "Label.publishedDate" | translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.updatedAt | date:'short'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="action" *ngIf="isPermissionExists">
                        <th id="action" class="resource-header-card" mat-header-cell *matHeaderCellDef>Action </th>
                        <td mat-cell *matCellDef="let row">
                            <span class="action-control col-md-1">
                                <a matTooltip="Click to Edit" class="action-control-delete cursor-pointer" (click)="onEdit(row);">
                                    <img alt="Edit" [src]="commonService.commonFiles['edit']">
                                </a>
                            </span>
                            <span class="action-control col-md-1">
                                <a matTooltip="Click to Delete" class="action-control-delete cursor-pointer" (click)="onDelete(row);">
                                    <img alt="Delete" [src]="commonService.commonFiles['delete']">
                                </a>
                            </span>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                </table>


            </div>
            <mat-paginator *ngIf="bannerDataSource && bannerDataSource.data.length >0" [pageSizeOptions]="[5,10,20]" showFirstLastButtons></mat-paginator>
            <div class="banner-action-controls mt-3" *ngIf="bannerDataSource && bannerDataSource.data.length >0">
                <span *ngIf="isPermissionExists">
                    <button *ngIf="bannerStatus === 'Publish'" [disabled]="this.selection.selected.length < 1" class="ml-2 btn btn-browse" (click)="previewBanner()"
                        type="button">Preview</button>
                    <button *ngIf="bannerStatus === 'Publish'" [disabled]="this.selection.selected.length < 1" class="ml-2 btn btn-browse" (click)="moveToDraft()"
                        type="button">Move To Draft</button>
                </span>
            </div>
        </div>
    </mat-tab>
    <mat-tab label="Draft">
        <app-draft-banner-list *ngIf="bannerStatus === 'Draft'"></app-draft-banner-list>
    </mat-tab>
</mat-tab-group>